<mat-card class="page-card page-wrapper">
  <mat-card-header>
    <mat-card-title>{{ 'performance.pageTitle' | translate }}</mat-card-title>
    <mat-card-subtitle class="lg-size-subtitle">
      {{ 'performance.pageSubTitle' | translate }}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <app-performance-summary-flag-selector
      [summaryFlagList]="SUMMARY_FLAGS_VALUES"
      [summaryFlag]="(performanceFacade.summaryFlag$ | async) || EPerformanceSummaryFlag.SUMMARY_COLUMN"
      (changeSummaryFlag)="performanceFacade.changeSummaryFlag($event)"
    ></app-performance-summary-flag-selector>

    @defer (on immediate) {
      <app-performance-rate-container></app-performance-rate-container>
    } @loading {
      <app-loading class="loading"></app-loading>
    }

    <mat-divider></mat-divider>

    <app-performance-period
      [queuerList]="(performanceFacade.quarterList$ | async) || []"
      [queuer]="performanceFacade.quarter$ | async"
      (changeQueuer)="performanceFacade.changeQuarter($event)"
    ></app-performance-period>

    <app-performance-total [queuer]="performanceFacade.quarter$ | async"></app-performance-total>

    <app-performance-navigation></app-performance-navigation>

    <div class="table-wrapper">
      @if ((performanceFacade.inRequest$ | async) === false) {
        <router-outlet></router-outlet>
      }
    </div>
  </mat-card-content>
</mat-card>
